/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:960px){#my-slider[_ngcontent-%COMP%]{width:99%!important}}.sp-image[_ngcontent-%COMP%], .sp-thumbnail[_ngcontent-%COMP%]{background-position:center;background-repeat:no-repeat;background-size:cover;height:100%}"];
export { styles as styles };
